import { IBuilderComponent } from "@faire/web/builder/registerBuilderComponents/types";

export const BuilderConfig: IBuilderComponent = {
  name: "PoundIcon",
  relativePath: "./Pound.tsx",
  propDefinition: {
    name: "SVGIcon.IProps",
    path: "../SVGIcon.tsx",
  },
  transformations: {
    component: null,
    className: null,
    children: null,
    shapeRendering: null,
    titleAccess: null,
    viewBox: null,
    strokeWidth: null,
    strokeLinecap: null,
    margin: null,
    fontSize: null,
    fill: null,
  },
  defaultValues: {
    height: "24",
    width: "24",
  },
  canHaveChildren: false,
  hideFromInsertMenu: true,
};
